/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import type {
  GetAggregatedDataReq,
  GetChartData200,
  GetChartDataBody,
  HTTPValidationError,
  PaginatedExtendedGroupByQuery,
} from '../model';

import { customFetch } from '../../fetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getGetAggregatedDataUrl = (projectId: string) => {
  return `/api/v1/reports/${projectId}/reports/aggregated-data`;
};

/**
 * @summary Aggregated Data
 */
export const getAggregatedData = async (
  projectId: string,
  getAggregatedDataReq: GetAggregatedDataReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedExtendedGroupByQuery> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<PaginatedExtendedGroupByQuery>(getGetAggregatedDataUrl(projectId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getAggregatedDataReq),
  });
};

export const getGetAggregatedDataMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAggregatedData>>,
    TError,
    GetAggregatedDataMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAggregatedData>>,
  TError,
  GetAggregatedDataMutationVariables,
  TContext
> => {
  const mutationKey = ['getAggregatedData'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAggregatedData>>,
    GetAggregatedDataMutationVariables
  > = (props) => {
    const { projectId, data } = props ?? {};

    return getAggregatedData(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAggregatedDataMutationResult = NonNullable<Awaited<ReturnType<typeof getAggregatedData>>>;
export type GetAggregatedDataMutationBody = GetAggregatedDataReq;
export type GetAggregatedDataMutationError = HTTPValidationError;
export type GetAggregatedDataMutationVariables = { projectId: string; data: GetAggregatedDataReq };

/**
 * @summary Aggregated Data
 */
export const useGetAggregatedData = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAggregatedData>>,
    TError,
    GetAggregatedDataMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getAggregatedData>>,
  TError,
  GetAggregatedDataMutationVariables,
  TContext
> => {
  return useMutation(getGetAggregatedDataMutationOptions(options));
};
export const getGetChartDataUrl = (projectId: string) => {
  return `/api/v1/reports/${projectId}/reports/chart-data`;
};

/**
 * @summary Chart Data
 */
export const getChartData = async (
  projectId: string,
  getChartDataBody: GetChartDataBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetChartData200> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GetChartData200>(getGetChartDataUrl(projectId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getChartDataBody),
  });
};

export const getGetChartDataMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getChartData>>,
    TError,
    GetChartDataMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof getChartData>>, TError, GetChartDataMutationVariables, TContext> => {
  const mutationKey = ['getChartData'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof getChartData>>, GetChartDataMutationVariables> = (
    props,
  ) => {
    const { projectId, data } = props ?? {};

    return getChartData(projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetChartDataMutationResult = NonNullable<Awaited<ReturnType<typeof getChartData>>>;
export type GetChartDataMutationBody = GetChartDataBody;
export type GetChartDataMutationError = HTTPValidationError;
export type GetChartDataMutationVariables = { projectId: string; data: GetChartDataBody };

/**
 * @summary Chart Data
 */
export const useGetChartData = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getChartData>>,
    TError,
    GetChartDataMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof getChartData>>, TError, GetChartDataMutationVariables, TContext> => {
  return useMutation(getGetChartDataMutationOptions(options));
};
